import { render, staticRenderFns } from "./ScormPlayer.vue?vue&type=template&id=36b4e0d4&"
import script from "./ScormPlayer.vue?vue&type=script&lang=ts&"
export * from "./ScormPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./ScormPlayer.vue?vue&type=style&index=0&id=36b4e0d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports